import React, { useRef, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import FormInputField from 'src/components/common/formInputField';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useSettingActions } from 'src/store/settings/actions';
const AddCreditJurisdiction = ({ editflag }: any) => {
  const dispatch = useDispatch();
  const settingAction = useSettingActions(dispatch);
  const ref = useRef<HTMLButtonElement>(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const { isCreditJurisdictionAdded, singleCreditJurisdictions } = useSelector(
    (state: RootState) => {
      return {
        isCreditJurisdictionAdded: state.setting.isCreditJurisdictionAdded,
        singleCreditJurisdictions: state.setting.singleCreditJurisdictions
      };
    }
  );
  useEffect(() => {
    if (isCreditJurisdictionAdded) {
      if (ref.current) {
        ref.current.click();
        handleCloseClick();
      }
    }
  }, [isCreditJurisdictionAdded]);

  const onSubmit = (data: any) => {
    if (editflag) {
      const payloadData = {
        id: data.id,
        updateData: [
          { op: 'replace', path: 'jurisdictionCode', value: data.jurisdictionCode },
          { op: 'replace', path: 'jurisdictionName', value: data.jurisdictionName },
          { op: 'replace', path: 'integrationId', value: data.integrationId },
          { op: 'replace', path: 'isActive', value: data.isActive },
          { op: 'replace', path: 'id', value: data.id }
        ]
      };
      settingAction.updateCreditJurisdictionsRequest(payloadData);
    } else {
      settingAction.addCreditJurisdictionsRequest(data);
    }
  };

  const handleCloseClick = () => {
    reset({
      jurisdictionCode: '',
      jurisdictionName: '',
      integrationId: '',
      isActive: false
    });
  };

  useEffect(() => {
    if (singleCreditJurisdictions) {
      reset(singleCreditJurisdictions);
    }
  }, [singleCreditJurisdictions]);

  return (
    <div>
      <div
        className="modal fade"
        id="AddCreditJurisdiction"
        aria-labelledby="AddCreditJurisdictionLabel"
        aria-hidden="true">
        <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
          <div className="modal-content">
            <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-semibold leading-normal text-center w-full"
                id="AddCreditJurisdictionLabel">
                Add CreditJurisdiction
              </h5>

              <button
                onClick={() => handleCloseClick()}
                ref={ref}
                type="button"
                className="dismiss-btn"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body relative py-4 px-10">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Jurisdiction Name'}
                    type={'text'}
                    fieldName={'jurisdictionName'}
                    register={register}
                    errors={errors}
                    isRequired={true}
                  />
                </div>
                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Jurisdiction Code'}
                    type={'text'}
                    fieldName={'jurisdictionCode'}
                    register={register}
                    errors={errors}
                    isRequired={true}
                  />
                </div>
                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Integration Id'}
                    type={'text'}
                    fieldName={'integrationId'}
                    register={register}
                    errors={errors}
                    isRequired={true}
                  />
                </div>
                <div className={`form-group mb-3`}>
                  <div className="flex items-center">
                    <div className="form-check form-switch pl-0 relative">
                      <input
                        className="form-check-input switch-btn"
                        type="checkbox"
                        role="switch"
                        id="isActive"
                        {...register('isActive')}
                      />
                      <i className="fas fa-check checkbox-tick hidden"></i>
                      <i className="fas fa-times checkbox-cross"></i>
                    </div>
                    <label
                      className="form-check-label inline-block font-semibold ml-2"
                      htmlFor="Credit">
                      Is Active
                    </label>
                  </div>
                </div>
                <div className="modal-footer mt-5 flex flex-shrink-0 flex-wrap items-center justify-center px-4 pb-2 rounded-b-md">
                  <button
                    type="submit"
                    className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0">
                    Save Changes
                  </button>
                  <button
                    onClick={() => handleCloseClick()}
                    type="button"
                    className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                    data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCreditJurisdiction;
